// Hai thẻ cuối: "Tiền tip" và "Cấu hình".
//
// Cả hai đều không dùng khoảng ngày ở đầu trang — tip đi theo tháng riêng, còn
// cấu hình là biểu mẫu cài đặt. Nhãn thẻ lấy từ từ điển nhãn của màn.

import { TAB_LABEL } from "@/features/payments/labels";
import type { GuideTab } from "../../types";

export const TABS_TIP_CAU_HINH: GuideTab[] = [
  {
    key: "tips",
    label: TAB_LABEL.tips,
    purpose: "Sổ tiền khách tặng thêm cho nhân sự, và chỗ gán khoản chưa biết của ai.",
    where: [
      'Ô "Tháng (YYYY-MM)" — gõ tháng muốn xem, ví dụ 2026-09.',
      'Ô "Trạng thái": Tất cả · Đã khớp · Chưa khớp · Đã loại.',
      "Cạnh hai ô đó: tổng tiền tặng của tháng, kèm nhãn đỏ đếm số khoản chưa khớp.",
      'Khối "Ghi tip tiền mặt / ngoài hệ thống" có ba ô: Nhân viên nhận · Số tiền · Mã đơn (tuỳ chọn), rồi nút "Ghi nhận".',
      "Bảng bên dưới: Ngày · Nội dung CK · Đơn · Người nhận · Số tiền · Trạng thái.",
      'Dòng chưa khớp có ô chọn nhân viên kèm nút "Gán", và nút "Chia đều cho ê-kíp" khi khoản đó gắn với một đơn.',
    ],
    howItWorks: [
      "Thẻ này đi theo THÁNG, không dùng khoảng ngày ở đầu trang — nên hàng chip ngày biến mất khi mở thẻ này.",
      "Khách chuyển tiền tặng vào tài khoản công ty với nội dung có mã đơn và mã nhân sự; khớp được thì khoản tự về đúng người, không khớp thì nằm lại chờ gán tay.",
      "Khoản đã gán sẽ vào bảng lương của kỳ đang chạy, nên gán sai người là tiền đi sai chỗ — đọc kỹ nội dung chuyển khoản trước khi gán.",
      'Khách tặng chung cả nhóm thì bấm "Chia đều cho ê-kíp": máy chia cho những người có tên trong đơn, khỏi gõ tay từng người.',
      "Khách đưa tiền tặng bằng tiền mặt thì ngân hàng không báo gì, phải ghi tay ở khối phía trên.",
      'Khách chuyển khoản DƯ so với phiếu thu và bên Kế toán xác nhận phần dư là tiền tặng: máy tự chia đều cho ê-kíp của đơn như khoản khách tặng cả nhóm, cột Nội dung CK ghi "Kế toán: khách chuyển dư trên phiếu thu …". Đơn chưa phân công ai thì khoản nằm "Chưa khớp" có gắn đơn — phân công xong bấm "Chia đều cho ê-kíp".',
    ],
    statuses: [
      { label: "Đã khớp", meaning: "Khoản đã về đúng người nhận." },
      { label: "Chưa khớp", meaning: "Chưa biết của ai, đang chờ gán tay." },
      { label: "Đã loại", meaning: "Khoản đã xác định không phải tiền tặng, không tính vào tổng." },
      { label: "(tay)", meaning: "Ghi chú cạnh ngày: khoản do người gõ vào, không do ngân hàng báo sang." },
    ],
    blocks: [
      {
        for: ["accounting"],
        title: "Dọn tiền tặng của tháng",
        steps: [
          "Gõ tháng cần xem vào ô tháng.",
          'Chọn Trạng thái là "Chưa khớp" để ra đúng phần còn phải xử.',
          "Đọc cột Nội dung CK của từng dòng để biết khách ghi tên ai.",
          'Rõ người nhận: chọn tên trong ô chọn rồi bấm "Gán".',
          'Khách tặng cả nhóm và khoản có gắn đơn: bấm "Chia đều cho ê-kíp".',
          'Khách đưa tiền mặt: điền khối "Ghi tip tiền mặt", chọn người nhận và số tiền rồi bấm "Ghi nhận".',
        ],
        troubles: [
          "Nội dung không nói được của ai: hỏi lại cơ sở trước khi gán, đừng đoán theo mã đơn.",
          'Không thấy tên người cần gán trong ô chọn: ô chỉ liệt kê nhân sự đang làm việc.',
          "Gán rồi mới biết sai người: báo ngay quản lý trực tiếp, vì khoản đó đã đi vào bảng lương kỳ này.",
        ],
      },
      {
        for: ["lead", "exec"],
        title: "Xem tiền khách tặng trong tháng",
        steps: [
          "Gõ tháng cần xem rồi đọc tổng tiền tặng ở cạnh hai ô lọc.",
          "Nhãn đỏ đếm số khoản chưa khớp — tồn nhiều nghĩa là tiền của nhân sự đang bị giữ lại chưa chia.",
          "Cột Người nhận cho biết khoản nào đã về tay ai.",
        ],
      },
    ],
  },

  {
    key: "config",
    label: TAB_LABEL.config,
    purpose: "Khai tài khoản nhận tiền và mức thuế mặc định cho đơn mới.",
    where: [
      'Khối trên "Tài khoản nhận tiền": ô chọn Ngân hàng, ô VietQR BIN, Số tài khoản, Tên chủ tài khoản, nút "Lưu cấu hình".',
      'Bên phải khối đó: khung "Preview QR" dựng thử mã theo đúng thông tin đang gõ.',
      'Khối dưới "VAT mặc định cho đơn hàng": ô tích áp dụng, ô nhập mức thuế, nút "Lưu cấu hình VAT".',
      "Thẻ này không dùng khoảng ngày, nên hàng chip ngày biến mất khi mở nó.",
    ],
    howItWorks: [
      "Thông tin tài khoản ở đây chính là thứ in ra trên mã QR khách quét, nên sửa một ký tự là mọi mã phát sau đó đổi theo — mã đã gửi cho khách trước đó thì không đổi.",
      'Khung "Preview QR" dựng thử ngay khi gõ đủ ba ô, chưa lưu gì cả: nhìn thử tên chủ tài khoản hiện ra có đúng không rồi mới bấm lưu.',
      "Mức thuế khai ở đây chỉ là mặc định cho đơn tạo MỚI; mỗi đơn giữ lại mức của riêng nó nên sửa ở đây không làm đổi đơn cũ.",
      "Hai khối lưu riêng bằng hai nút riêng — sửa khối trên rồi bấm nút của khối dưới thì phần sửa không được lưu.",
    ],
    statuses: [
      {
        label: "Nhập đủ thông tin để xem QR mẫu",
        meaning: "Khung xem thử báo còn thiếu một trong ba ô bắt buộc.",
      },
    ],
    blocks: [
      {
        for: ["exec"],
        title: "Đổi tài khoản nhận tiền",
        steps: [
          "Chọn ngân hàng trong ô chọn; ngân hàng không có trong danh sách thì gõ thẳng mã vào ô VietQR BIN.",
          "Điền số tài khoản và tên chủ tài khoản đúng như trên sổ ngân hàng.",
          "Nhìn khung xem thử bên phải: tên chủ tài khoản hiện ra phải khớp.",
          'Khớp rồi bấm "Lưu cấu hình".',
          'Đổi mức thuế mặc định thì sửa ở khối dưới và bấm "Lưu cấu hình VAT" — nút riêng của khối đó.',
        ],
        troubles: [
          "Khung xem thử báo thiếu thông tin: còn một trong ba ô chưa điền.",
          "Vừa lưu xong mà mã cũ vẫn hiện thông tin cũ: mã đã phát trước đó giữ nguyên, chỉ mã phát sau mới theo tài khoản mới.",
          "Sửa hai khối rồi chỉ bấm một nút: bấm nốt nút của khối kia, mỗi khối lưu riêng.",
        ],
      },
    ],
  },
];
